import { Alert, AlertTitle, Button, Stack, Typography } from '@mui/material'

import { useTexts } from '../hooks/useTexts'
import { LocationEditorProps } from '../types'
import { getLocationAccuracy } from '../utils/getLocationAccuracy'

export function LocationAlert(props: LocationEditorProps) {
  const { location, disabled, onConfirmLowAccuracy, onFixInvalidAddress } = props
  const {
    warning: { lowAccuracy, outOfTerritory, invalidLatLng },
  } = useTexts()

  if (disabled) return null

  const accuracy = getLocationAccuracy(location)

  switch (accuracy) {
    case 'out-of-territory':
      return (
        <Alert severity="error" data-testid="WarningCard">
          <AlertTitle>{outOfTerritory.title}</AlertTitle>
          <Typography variant="body2">{outOfTerritory.description}</Typography>
          <Typography variant="body2">{outOfTerritory.subText}</Typography>
        </Alert>
      )

    case 'invalid-latLng':
      return (
        <Alert severity="error" data-testid="WarningCard">
          <AlertTitle>{invalidLatLng.title}</AlertTitle>
          <Stack spacing={1} alignItems="flex-start">
            <Typography variant="body2">{invalidLatLng.description}</Typography>
            <Button onClick={onFixInvalidAddress}>{invalidLatLng.action}</Button>
          </Stack>
        </Alert>
      )

    case 'low-accuracy':
      return (
        <Alert severity="warning" data-testid="WarningCard">
          <AlertTitle>{lowAccuracy.title(location.status)}</AlertTitle>
          <Stack spacing={1} alignItems="flex-start">
            <Typography variant="body2">{lowAccuracy.description(location.status)}</Typography>
            <Button onClick={onConfirmLowAccuracy}>{lowAccuracy.confirm}</Button>
          </Stack>
        </Alert>
      )
  }
}
